import { makeAutoObservable } from "mobx";

export const roleOptions = [
  { label: "Nurse", value: "NURSE" },
  { label: "Monitor Tech", value: "MONITOR_TECH" },
];
export default class PrefsStore {
  roleOptions = roleOptions;
  selectedRoleOption = roleOptions[0];

  constructor() {
    makeAutoObservable(this);
  }
}
